import { render, staticRenderFns } from "./creditExtension.vue?vue&type=template&id=588cf48c&scoped=true"
import script from "./creditExtension.vue?vue&type=script&lang=js"
export * from "./creditExtension.vue?vue&type=script&lang=js"
import style0 from "./creditExtension.vue?vue&type=style&index=0&id=588cf48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588cf48c",
  null
  
)

export default component.exports